import React from "react";
import logo from "../../assets/images/login-human-icon.svg";

const loginLogo = props => (
  <img className={props.className} src={logo} alt="user" />
);

export default loginLogo;
